import { AnnouncementViewModel } from '@moal/types'

interface AnnouncementsProviderReducerState {
  announcements: AnnouncementViewModel[]
  loading: boolean
  error: string
  loadMore: Date
  hasMore: boolean
}

interface LoadingAction {
  type: 'LOADING'
}

interface ErrorAction {
  type: 'ERROR'
  payload: string
}

interface FetchAnnouncementEventsAction {
  type: 'FETCH_ANNOUNCEMENT_EVENTS'
  payload: AnnouncementViewModel[]
}

interface AnnouncementPostAction {
  type: 'ANNOUNCEMENT_POST'
  payload: AnnouncementViewModel
}

interface AnnouncementPutAction {
  type: 'ANNOUNCEMENT_PUT'
  payload: AnnouncementViewModel
}

interface AnnouncementDeleteAction {
  type: 'ANNOUNCEMENT_DELETE'
  payload: AnnouncementViewModel
}

interface AnnouncementReadAllAction {
  type: 'ALL_READ'
}

type AnnouncementsProviderReducerAction =
  | LoadingAction
  | ErrorAction
  | FetchAnnouncementEventsAction
  | AnnouncementPostAction
  | AnnouncementPutAction
  | AnnouncementDeleteAction
  | AnnouncementReadAllAction

export const initialState: AnnouncementsProviderReducerState = {
  announcements: [],
  loading: true,
  error: '',
  loadMore: new Date(),
  hasMore: true
}

export function reducer(
  state: AnnouncementsProviderReducerState,
  action: AnnouncementsProviderReducerAction
) {
  switch (action.type) {
    case 'LOADING':
      return {
        ...state,
        loading: true,
        error: ''
      }
    case 'ERROR':
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case 'FETCH_ANNOUNCEMENT_EVENTS':
      return {
        ...state,
        loading: false,
        error: '',
        announcements: [...state.announcements, ...action.payload],
        loadMore:
          action.payload.length > 0
            ? action.payload[action.payload.length - 1]?.createdAt
            : new Date(),
        hasMore: action.payload.length === 0 ? false : action.payload.length > 0
      }
    case 'ANNOUNCEMENT_POST':
      return {
        ...state,
        announcements: [action.payload, ...state.announcements]
      }
    case 'ANNOUNCEMENT_PUT':
      return {
        ...state,
        announcements: state.announcements.map((announcement) =>
          announcement._id === action.payload._id
            ? action.payload
            : announcement
        )
      }
    case 'ANNOUNCEMENT_DELETE':
      return {
        ...state,
        announcements: state.announcements.filter(
          (announcement) => announcement._id !== action.payload._id
        )
      }
    case 'ALL_READ':
      return {
        ...state,
        announcements: state.announcements.map((announcement) => ({
          ...announcement,
          read: new Date()
        }))
      }
    default:
      return state
  }
}
